import { RootState } from "@/store/store";
import { gridResourcesCurrentCleanResourcesSelector } from "@/store/resources-grid/selectors/clean/resources/gridResourcesCurrentCleanResourcesSelector";

export const gridResourcesCurrentCleanResourcesCountSelector = (
  state: RootState,
) => {
  const resources = gridResourcesCurrentCleanResourcesSelector(state);

  return resources?.length;
};
